<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        육아휴직(추가) 신청
      </v-col>
    </v-row>
    <!-- 휴직기간-->

    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field label="휴직기간" v-model="leaveDt" readonly></v-text-field>
      <span>복직예정일은 {{ reInDate }}일 입니다</span>
      <v-text-field
        label="자녀명/관계"
        v-model="famInfo"
        readonly
      ></v-text-field>
      <v-text-field label="생년월일" v-model="famYmd" readonly></v-text-field>
      <v-text-field label="휴직기간" v-model="famAddDay" readonly></v-text-field>
      <v-text-field label="육아휴직가능일수" v-model="remainDaysBefore" readonly></v-text-field>
      <v-text-field label="잔여일수" v-model="remainDays" readonly></v-text-field>
      <v-text-field label="신청사유" v-model="refReason"></v-text-field>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg/
import routerNames from '@/const/routerConstants';
import { getExtParAddAppDetMap } from '@/api/workStatus';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';

export default {
  data: () => ({
    reInDate: '',
    period: '',
    famNm: '',
    refReason: '',
    leaveDt: '',
    famInfo: '',
    famYmd: '',
    leaveEndDt: '',
    stdYmd: '',
    orgApplSeq: '',
    famCd: '',
    famSeq: '',
    orgTmpRestEndPlanYmd: '',
    orgReinstPlanYmd: '',
    orgFamNm: '',
    orgSabun: '',
    caDays: '',
    orgUseRestDCnt: '',
    orgStaYmd: '',
    fileFlag: false,
    fileShow: true,
    remainDaysBefore: '',
    famAddDay: '',
    remainDays: '',
  }),

  components: {
    IconApprovalDoc,
    BgfAttachFileAdd,
    BgfAttachFileBottomSelect,
  },

  computed: {
    ...mapGetters('ELA', [
      'GET_S_YMD',
      'GET_E_YMD',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
      'GET_APPL_USER_LIST',
    ]),
    ...mapGetters([
      'GET_APPL_CD',
      'GET_CODE',
      'GET_CODE1',
      'GET_BIRTHDAY',
      'GET_CODE_NM',
      'GET_USER_DATA',
      'GET_LIMIT_TERM',
      'GET_FAM_SEQ',
      'GET_APPL_SEQ',
      'GET_ORG_APPL_SEQ',
      'GET_APPL_CD',
      'GET_FILE_SEQ',
      'GET_PARAMS',
      'GET_ADD_DAY',
      'GET_REMAIN_DAYS_BEFORE',
    ]),
  },

  methods: {
    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },

    async applovalPage() {
      if (this.refReason.trim() === '') {
        alert('변경사유를 입력해 주세요');
        return;
      }

      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '') {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        ssnSabun: this.GET_USER_DATA.ssnSabun,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        applTypeCd: '10', //본인신청
        staYmd: this.GET_S_YMD,
        tmpRestEndPlanYmd: this.GET_E_YMD,
        reinstPlanYmd: this.reInDate,
        famCd: this.famCd,
        famNm: this.famNm,
        searchApplSeq2: this.orgApplSeq,
        orgStaYmd: this.orgStaYmd,
        orgTmpRestEndPlanYmd: this.orgTmpRestEndPlanYmd,
        orgReinstPlanYmd: this.orgReinstPlanYmd,
        orgNote: this.orgNote,
        note: this.refReason,
        famSeq: this.famSeq,
        orgFamNm: this.orgFamNm,
        orgSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        updStaYmd: dayjs().format('YYYYMMDD'),
        caDays: this.period,
        //remainDaysBefore: this.orgUseRestDCnt,
        //usedDaysBefore: this.orgUseRestDCnt - this.period,
        remainDaysBefore: this.remainDaysBefore,
        usedDaysBefore: this.usedDaysBefore,
        //usedDaysBefore: this.GET_LIMIT_TERM - this.period, 현재는 사용하지 않음
        applCd: this.GET_APPL_CD,
      };

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_LEAABS_PARAMS', params);
      this.$router.push(routerNames.ApprovalLine);
    },

    addDate(pInterval, pAddVal, pYyyymmdd, pDelimiter) {
      var yyyy;
      var mm;
      var dd;
      var cDate;
      var cYear, cMonth, cDay;

      if (pYyyymmdd == '') {
        return '';
      }

      if (pDelimiter != '') {
        pYyyymmdd = pYyyymmdd.replace(eval('/\\' + pDelimiter + '/g'), '');
      }

      yyyy = pYyyymmdd.substr(0, 4);
      mm = pYyyymmdd.substr(4, 2);
      dd = pYyyymmdd.substr(6, 2);

      if (pInterval == 'yyyy') {
        yyyy = yyyy * 1 + pAddVal * 1;
      } else if (pInterval == 'm') {
        mm = mm * 1 + pAddVal * 1;
      } else if (pInterval == 'd') {
        dd = dd * 1 + pAddVal * 1;
      }

      cDate = new Date(yyyy, mm - 1, dd); // 12월, 31일을 초과하는 입력값에 대해 자동으로 계산된 날짜가 만들어짐.
      cYear = cDate.getFullYear();
      cMonth = cDate.getMonth() + 1;
      cDay = cDate.getDate();

      cMonth = cMonth < 10 ? '0' + cMonth : cMonth;
      cDay = cDay < 10 ? '0' + cDay : cDay;

      //if (pDelimiter != "") {
      return cYear + pDelimiter + cMonth + pDelimiter + cDay;
      //} else {
      //	return cYear + cMonth + cDay;
      //}
    },
  },

  async mounted() {
    const todayYMD = dayjs().format('YYYYMMDD');
    const ssnSabun = this.GET_USER_DATA.ssnSabun;

    await this.$store.dispatch('ELA/FETCH_ELA_APPL_INFO', {
      searchApplCd: this.GET_APPL_CD,
      adminYn: 'N',
      authPg: 'A',
      searchApplSeq: null,
      searchApplSabun: ssnSabun,
      searchApplInSabun: ssnSabun,
      searchApplStatusCd: '21', // 신청
      searchApplYmd: todayYMD,
    });

    let params = {
      searchApplSeq: this.GET_APPL_SEQ,
      searchApplSeq2: this.GET_ORG_APPL_SEQ,
    };

    let response = await getExtParAddAppDetMap(params);
    console.dir(response)

    this.leaveDt = this.GET_S_YMD + ' ~ ' + this.GET_E_YMD;
    this.famCd = response.data.data.orgFamCd;
    this.famNm = response.data.data.famNm;
    this.famInfo = response.data.data.famNm + ' / ' + response.data.data.famCd;
    this.famYmd = response.data.data.famYmd + ' / ' + response.data.data.famAge;
    this.famSeq = response.data.data.famSeq;
    this.orgApplSeq = response.data.data.orgApplSeq;
    this.orgTmpRestEndPlanYmd = response.data.data.orgTmpRestEndPlanYmd;
    this.orgReinstPlanYmd = response.data.data.orgReinstPlanYmd;
    this.orgNote = response.data.data.orgNote;
    this.orgFamNm = response.data.data.orgFamNm;
    //this.orgSabun = response.data.data.orgSabun;
    this.reInDate = this.addDate('d', 1, this.GET_E_YMD, '-');
    //this.orgUseRestDCnt = response.data.data.orgUseRestDCnt;
    this.orgStaYmd = response.data.data.orgStaYmd;

    const oldDate = new Date(this.GET_S_YMD);
    const newDate = new Date(this.GET_E_YMD);
    let diff = Math.abs(newDate.getTime() - oldDate.getTime());
    diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

    this.period = diff + 1;
    this.leaveEndDt = this.GET_S_YMD + ' / ' + this.period + '일';

    this.refReason =
      this.GET_PARAMS.note === undefined ? '' : this.GET_PARAMS.note;

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    }

    this.remainDaysBefore = this.GET_REMAIN_DAYS_BEFORE;
    this.famAddDay = this.GET_ADD_DAY===null?this.period:this.GET_ADD_DAY;
    this.remainDays = this.GET_REMAIN_DAYS_BEFORE - (this.GET_ADD_DAY===null?this.period:this.GET_ADD_DAY);
  },
};
</script>

<style></style>
